<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Felhasználói csoportok</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/users/categories/add')"
            icon="el-icon-plus"
            v-can="'usercategory.create'"
          >
            Új Felhasználói csoport
          </el-button>
        </div>
        <list />
        <template v-if="$route.meta.showAddUserCategoryDialog">
          <category-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateUserCategoryDialog">
          <category-dialog
            :userCategoryId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../components/users/Sidebar';
  import List from '../../components/users/categories/List';
  import CategoryDialog from '../../components/users/categories/Dialog';

  export default {
    components: {
      Sidebar,
      List,
      CategoryDialog,
    }
  };
</script>
